import { GpsTrackersPlataformaService } from "../../../shared/generated/grpc/plataforma_hardware_gps_trackers_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { GpsTrackerService } from "./GpsTrackerService";

/** Baja de GPS trackers; la saca del listado en memoria. */
export class GpsTrackerDeleteService extends ServiceDeleteBase {
  protected readonly cache = GpsTrackerService.instance;

  /** gRPC-Web (`Eliminar`): baja lógica, idempotente. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(GpsTrackersPlataformaService).eliminar({ id }));
  }
}
